__webpack_require__.p = "https://omnichannel-frontend.stagecliengo.com/";